/* Header */
  $(function(){
  	// more settings: https://github.com/mattboldt/typed.js/#customization
    $(".typed").typed({
      strings: ["event", "budget", "preference"],
      typeSpeed: 50,
      backDelay: 1000,
      loop: true,
      shuffle: false
    });
  });